export const updateGeneralQuestion = (payload?: any) => ({
    type: "@saga/UPDATE_GENERAL_QUESTION",
    payload
});

